export default "__VITE_ASSET__98d9c7db__"